export default __webpack_public_path__ + "a2f75989924952a7e49ce0405d487c93.png";